module.exports = __webpack_public_path__ + "static/img/logo_big.d522f1ef.svg";